import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element"
import FieldPopover_FormComponent from "../components/form/form-component"

export default class FieldPopover_FormElement extends FieldProto_FormElement {

    render() {
        // const classes = Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", this.props.className)

        return <FieldPopover_FormComponent className    = {this.props.className}
                                           field        = {this.props.field}
                                           value        = {this.value}
                                           disabled     = {this.props.disabled}
                                           model        = {this.props.model}
                                           onChange     = {this.onChange}/>
    }
}